import React from 'react';
import { QuestionHeading, QuestionOptionsList } from './QuestionBlockShared';

function MultipleChoiceBlock({ block, position }) {
    return (
        <div className="ecx-survey-q">
            <QuestionHeading block={block} position={position} />
            <QuestionOptionsList block={block} control="checkbox" />
        </div>
    );
}

export default MultipleChoiceBlock;
